import { getImage } from '../utils/utils';

const RankingItem = ({contestant, rank, score}) => {
    const {name, number} = contestant;
    
    return (
        <tr className='is-size-5 has-text-vcentered'>
            <td>{rank}</td>
            <td>
                <figure className="image is-4by5" style={{overflow: "hidden"}}>
                    <img src={getImage(number)} alt={name} style={{height: "initial"}}/>
                </figure>
            </td>
            <td className='has-text-weight-medium has-text-left'>#{number + " " + name}</td>
            <td>{score}</td>
        </tr>
    )
}

export default RankingItem;